import { useState, useEffect } from "react";

const useMobileView = (breakpoint = 768) => {
  const isMobileMediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);
  const [isMobileView, setIsMobileView] = useState(isMobileMediaQuery.matches);

  useEffect(() => {
    const handleMediaQueryChange = e => {
      setIsMobileView(e.matches);
    };
    isMobileMediaQuery.addEventListener("change", handleMediaQueryChange);

    return () =>
      isMobileMediaQuery.removeEventListener("change", handleMediaQueryChange);
  }, [isMobileMediaQuery]);

  return isMobileView;
};

export default useMobileView;
